import React from 'react'
import { CheckCircleIcon, XCircleIcon } from '@primer/octicons-react'
import { dasherize } from '@/utilities'

const MatchConstituyenteBox = ({ fecharespuestacuestionario, nombre }) => {
  const firstname = nombre.split(' ')[0]
  return (
    <div>
      {fecharespuestacuestionario ? (
        <p className="block p-4 mb-4 text-base leading-none text-center align-baseline bg-gray-300 rounded-default ">
          <a
            rel="noopener noreferrer"
            target="_blank"
            href={`https://interactivo.latercera.com/tu-match-constituyente/candidatos-constituyentes/?utm_source=interactivo.latercera.com&amp;utm_medium=ficha-candidatos-constituyentes&amp;utm_content=${dasherize(
              nombre,
            )}`}>
            <span className="inline-block bg-gray-300 rounded-full">
              <CheckCircleIcon className=" text-green" size={16} />
            </span>
            <span>
              {' '}
              {firstname} <strong>sí contestó</strong> nuestra encuesta.
              <br />
              ¿Quieres conocer sus ideas?
              <br />
              <span className="inline-block px-6 py-2 mt-4 text-white transition-all duration-500 ease-in-out rounded-full bg-azul border-azul hover:bg-rojo">
                Ir al <strong>Match Constituyente</strong>
              </span>
            </span>
          </a>
        </p>
      ) : (
        <p className="block p-4 mb-4 text-base leading-none text-center align-baseline bg-gray-300 rounded-default ">
          <a
            target="_blank"
            href={`https://interactivo.latercera.com/tu-match-constituyente/candidatos-constituyentes/?utm_source=interactivo.latercera.com&amp;utm_medium=ficha-candidatos-constituyentes&amp;utm_content=${dasherize(
              nombre,
            )}`}>
            <XCircleIcon size={16} className="text-rojo " />
            <span>
              {' '}
              {firstname} <strong>no ha contestado</strong> nuestra encuesta.
              <br />
              ¿Quieres encontrar a constituyentes que coincidan contigo?
              <br />
              <span className="inline-block px-6 py-2 mt-4 text-white transition-all duration-500 ease-in-out rounded-full bg-azul border-azul hover:bg-rojo">
                Ir al <strong>Match Constituyente</strong>
              </span>
            </span>
          </a>
        </p>
      )}
    </div>
  )
}

export default MatchConstituyenteBox
